
export function _dummyNull(): null
{
	return null
}

export function _dummyVoid(): void
{
	return void 0
}
